// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1DVZO","modalForm":"UpgradeEpcsModal_modalForm__IrZwE","modalFooter":"UpgradeEpcsModal_modalFooter__ER5Zz"};